import type { ReactElement } from 'react';
import type { OnUserInteraction, ToolInvocationEvent } from '../types';
import mergeIncidentsApprovalRenderer from '../toolRenderers/MergeIncidentsToolRenderer/MergeIncidentsToolRenderer';
import applyCloudTestConfigPlanApprovalRenderer from '../toolRenderers/ApplyCloudTestConfigPlanToolRenderer';
import applyCodeTestConfigPlanApprovalRenderer from '../toolRenderers/ApplyCodeTestConfigPlanToolRenderer';

export type ApprovalToolRendererProps = {
  invocation: ToolInvocationEvent['toolInvocation'];
  onApproveToolUse: (
    approved: boolean,
    newArgs?: Record<string, unknown>,
  ) => void;
  onUserInteraction?: OnUserInteraction;
  isActive: boolean;
};

export type ApprovalToolRendererFn = (
  props: ApprovalToolRendererProps,
) => ReactElement | null;

const approvalRendererMap: Record<string, ApprovalToolRendererFn> = {
  merge_incidents: mergeIncidentsApprovalRenderer,
  apply_cloud_test_config_plan: applyCloudTestConfigPlanApprovalRenderer,
  apply_code_test_config_plan: applyCodeTestConfigPlanApprovalRenderer,
};

export const getApprovalToolRenderer = (
  toolName?: string,
): ApprovalToolRendererFn | undefined =>
  toolName ? approvalRendererMap[toolName] : undefined;
